<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script lang="ts">
import "normalize.css"
import { defineComponent } from "vue"
import store from "./store"

export default defineComponent({
  name: "App",
  methods: {
    handleResize: function() {
      store.commit('windowWidth', window.innerWidth)
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount: function () {
    window.removeEventListener('resize', this.handleResize)
  },
})
</script>

<style lang="scss">
body {
  margin: 0;
}

h1 {
  font-size: 22px;
}

h2 {
  font-size: 20px;
}

h1, h2, h3 {
  color: #000;
}

#app {
  font-family: "游ゴシック", YuGothic, "メイリオ", Meiryo, "ヒラギノ角ゴ ProN W3", "Hiragino Kaku Gothic ProN", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #666666;
}
</style>
